import React, { useGlobal, useState, useEffect } from 'reactn';
import { Button } from 'primereact/button';
import TablaRegistros from "./TablaRegistros";
import { obtenerRegistrosCalidadInicialDia } from '../../../service/Calidad';
import { obtenerHoraRegistro, obtenerNombreDiaSemana, obtenerNumeroSemana } from '../../../service/fechas';
import { noHaSidoClausurado } from '../../../service/Ciclos';
import { getProductoYVariedadString, getNombrePorID } from '../../../util/functions';
import ContenedorHeader from '../../common/ContenedorHeader';
import icono from '../../../images/icons/external-icon.svg';

const TablaInicial = (props) => {
    const [, setHabilitadoSelectorCiclo] = useGlobal("habilitadoSelectorCiclo");
    const [invernadero] = useGlobal("invernadero");
    const [registros, setRegistros] = useState([]);
    const [, setCargando] = useGlobal("cargando");
    const [defectos] = useGlobal("defectos");
    const [ciclo,] = useGlobal("ciclo")
    const [ciclos,] = useGlobal("ciclos")
    const [diaConsultado,] = useGlobal("diaConsultado");
    const [proveedores] = useGlobal("proveedores");
    const [proveedor] = useGlobal("proveedorExternoCalidad");
    const [allVariedades] = useGlobal("allVariedades");
    const [colores] = useGlobal("coloresVariedades");

    useEffect(() => {
        setHabilitadoSelectorCiclo(false)
    }, [])
    useEffect(() => {
        setCargando(true)
        if (!diaConsultado) { props.history.replace("/calidad/semanal"); }
        else if (invernadero) { obtenerDatosIniciales(); }
    }, [invernadero])

    const puedeEditar = () => noHaSidoClausurado(ciclo, ciclos) && (!invernadero?.es_externo || proveedor?.habilitado) && invernadero && (invernadero?.habilitado || invernadero?.es_externo);
    const obtenerDatosIniciales = async () => {
        let registros = await obtenerRegistrosCalidadInicialDia(ciclo, invernadero?.id, diaConsultado);
        if (invernadero?.es_externo && proveedor && proveedor.id !== "todos") { registros = registros.filter(el => el.proveedor === proveedor.id); }

        let procesados = registros.map((registro) => ({
            ...registro,
            id: registro.id,
            momento: obtenerHoraRegistro(registro.momento),
            peso_real_caja: registro.peso_real_caja,
            defectos: registro.defectos.map(el => getNombrePorID(defectos, el.defecto_ref)).join(", ")
        }))
        setRegistros(procesados);
        setCargando(false);
    }

    const getTitulo = () => `Calidad inicial del dia - ${obtenerNombreDiaSemana(diaConsultado)} - semana ${obtenerNumeroSemana(diaConsultado)}`;
    const columnasTablaInicial = () => {
        const columnas = [
            { nombre: "HORA DE REGISTRO", field: "momento" },
            { nombre: "PESO CAJA (kg)", field: "peso_real_caja" },
            { nombre: "DEFECTOS", field: "defectos" },
        ];
        if (invernadero.mezcla) { columnas.push({ nombre: "Variedad", field: "subVariedad_ref" }); }
        if(invernadero.es_externo) { columnas.push({ nombre: "Proveedor", field: "proveedor" }); }
        return columnas;
    }

    return (
        <div className="p-grid p-justify-center">
            <ContenedorHeader col="p-col p-col-auto" titulo={getTitulo()} subtituloInv={getProductoYVariedadString(invernadero)}
                invernaderoNombre={invernadero?.es_externo ? <img width="60" alt="icono" src={icono} /> : invernadero?.nombre}
                iconos={`icon-general icon-id bor-${invernadero?.color} bg-${invernadero?.color} ${invernadero?.habilitado ? "" : "Deshabilitado"}`} atras={props.history.goBack} />

            <div className="p-col p-col-auto">
                <div className="btn-row">
                    {puedeEditar() && <Button label="Agregar nuevo registro" onClick={() => props.history.push("/calidad/registro_inicial/crear")} />}
                </div>
            </div>
            <div className="p-col-12">
                {invernadero &&
                    <TablaRegistros registros={registros} columnas={columnasTablaInicial()} rutaEdicion={`/calidad/registro_inicial/${invernadero?.id}/modificar`}
                        variedades={allVariedades} colores={colores} proveedores={proveedores}/>}
            </div>
        </div>);
}
export default TablaInicial;